<template>
  <div class="lnb" :class="lnbColor">
    <ul class="menu">
      <li :class="{ active: contentsName === 'Sub6Page' }"><a @click="changeContentsName('Sub6')">find a boutique</a></li>
      <li :class="{ active: contentsName === 'Sub4Page' }"><a @click="changeContentsName('Sub4')">lookbook</a></li>
      <li :class="{ active: contentsName === 'Sub5Page' }"><a @click="changeContentsName('Sub5')">made to order</a></li>
      <li :class="{ active: contentsName === 'Sub2Page' }"><a @click="changeContentsName('Sub2')">shop</a></li>
      <li :class="{ active: contentsName === 'Sub1Page' }"><a @click="changeContentsName('Sub1')">about</a></li>
    </ul>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'Lnb',
    data () {
      return {

      }
    },
    computed: {
      ...mapState([
        'contentsName',
        'lnbColor'
      ])
    },
    methods: {
      ...mapMutations([
        'changeContentsName'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Lnb.vue